import {
  additionnalsInformationsInputType,
  JobModuleTranslationKeys,
  JobPriority,
  JobRecruiterAccess,
  RejectionReason,
  TranslateKey,
} from '@job-v2/ats-utils';

export const LANGUAGE_I18N = 'LANGUAGE_I18N';

export const JOB_LOGO = 'assets/logos/job.svg';
export const DEFAULT_PROFILE_PIC = 'assets/avatars/profile.webp';

export const CONTENT_TYPE = 'Content-Type';
export const APPLICATION_JSON = 'application/json';
export const TOKEN_KEY = 'Authorization';

export const LS_CURRENT_AUTH_USER = 'CURRENT_AUTH_USER';
export const LS_TOKEN_DATA = 'TOKEN_DATA';
export const LS_SELECTED_COMPANY = 'SELECTED_COMPANY';
export const LS_COLLAPSE_STATE_MENU = 'LS_COLLAPSE_STATE_MENU';
export const LS_COLLAPSE_STATE_APPS = 'LS_COLLAPSE_STATE_APPS';
export const LS_JOB_STATUS_FILTER = 'JOB_STATUS_FILTER';
export const LS_JOB_INDEX_PAGINATION_PAGE = 'JOB_INDEX_PAGINATION_PAGE';
export const LS_JOB_INDEX_PAGINATION_LIMIT = 'JOB_INDEX_PAGINATION_LIMIT';
export const LS_JOB_INDEX_PAGINATION_FIRST = 'JOB_INDEX_PAGINATION_FIRST';
export const LS_JOB_INDEX_COMPANY_FILTER = 'JOB_INDEX_COMPANY_FILTER';



export const LINKEDIN_SHARE_LINK = 'https://www.linkedin.com/shareArticle';
export const TWITTER_SHARE_LINK = 'https://twitter.com/share';
export const FACEBOOK_SHARE_LINK = 'https://www.facebook.com/sharer.php';

  
export enum DialogOnCloseAction {
  RELOAD = "reload",
  DELETE = "delete",
  UPDATE = "update",
  ADD = "add"
}
export const REJECTION_OPTIONS = [
  {
    label: JobModuleTranslationKeys.REJECTED_BY_COMPANY,
    value: RejectionReason.REJECTED_BY_COMPANY,
  },
  {
    label: JobModuleTranslationKeys.REJECTED_BY_CANDIDATE,
    value: RejectionReason.REJECTED_BY_CANDIDATE,
  },
];

export const REMOTE_WORKS_TYPES = [
  { code: 'TOTAL', label: TranslateKey.REMOTE_WORK_TOTAL },
  { code: 'PARTIEL', label: TranslateKey.REMOTE_WORK_PARTIAL },
  { code: 'PONCTUEL', label: TranslateKey.REMOTE_WORK_PUNCTUAL },
  { code: 'NONSPECIFIE', label: TranslateKey.REMOTE_WORK_NOT_SPECIFIED },
];

export const DOC_TYPES = [
  { code: 'CV', label: TranslateKey.APPLICATION_DOCUMENT_CV },
  { code: 'COVER_LETTER', label: TranslateKey.APPLICATION_DOCUMENT_LM },
];

export const INPUT_NUMBER_FILTER_OPTIONS = [
  { label: TranslateKey.BOARD_FILTER_INF_TO, value: '<' },
  { label: TranslateKey.BOARD_FILTER_SUP_TO, value: '>' },
  { label: TranslateKey.BOARD_FILTER_EQUAL_TO, value: '=' },
  { label: TranslateKey.BOARD_FILTER_NOT_EQUAL_TO, value: '!=' }
];

export const EDUCATIONS_LEVELS = [
  { code: 'NO_DIPLOMA', label: TranslateKey.EDUCATION_LEVEL_NO_DIPLOMA, year: 0 },
  { code: 'CAP', label: TranslateKey.EDUCATION_LEVEL_CAP, year: 0 },
  { code: 'BEP', label: TranslateKey.EDUCATION_LEVEL_BEP, year: 0 },
  { code: 'BAC', label: TranslateKey.EDUCATION_LEVEL_BAC, year: 1 },
  { code: 'BAC_1', label: TranslateKey.EDUCATION_LEVEL_BAC_1, year: 1 },
  { code: 'BAC_2', label: TranslateKey.EDUCATION_LEVEL_BAC_2, year: 2 },
  { code: 'BAC_3', label: TranslateKey.EDUCATION_LEVEL_BAC_3, year: 3 },
  { code: 'BAC_4', label: TranslateKey.EDUCATION_LEVEL_BAC_4, year: 4 },
  { code: 'BAC_5', label: TranslateKey.EDUCATION_LEVEL_BAC_5_MASTER, year: 5 },
  { code: 'PHD', label: TranslateKey.EDUCATION_LEVEL_BAC_5_DOCTORATE, year: 8 }
]

export enum EXPERIENCES_CONDITION_OPTIONS_ENUM {
  GREATER = 'GREATER',
  LESS = 'LESS',
  EQUAL = 'EQUAL',
}

export const EXPERIENCES_CONDITION_OPTIONS = [
  {
    code: EXPERIENCES_CONDITION_OPTIONS_ENUM.EQUAL,
    label: TranslateKey.EXPERIENCE_LEVEL_EQUAL
  },
  {
    code: EXPERIENCES_CONDITION_OPTIONS_ENUM.LESS,
    label: TranslateKey.EXPERIENCE_LEVEL_LESS_THAN
  },
  {
    code: EXPERIENCES_CONDITION_OPTIONS_ENUM.GREATER,
    label: TranslateKey.EXPERIENCE_LEVEL_GREATER_THAN
  }
];

export type SeverityType =
  | 'danger'
  | 'secondary'
  | 'warn'
  | 'success'
  | 'info'
  | 'help'
  | 'primary'
  | 'contrast';
export const SALARY_FREQUENCIES = [
  { code: 'JOURNALIER', label: TranslateKey.FREQUENCY_DAILY },
  { code: 'MENSUEL', label: TranslateKey.FREQUENCY_MONTHLY },
  { code: 'ANNUEL', label: TranslateKey.FREQUENCY_YEARLY },
  { code: 'NONSPECIFIE', label: TranslateKey.FREQUENCY_NOT_SPECIFIED },
];

export const REQUESTED_DOCS_STATUS = [
  {
    code: 'MANDATORY',
    label: JobModuleTranslationKeys.REQUESTED_DOCS_STATUS_MANDATORY,
    severity: 'danger',
  },
  {
    code: 'NOT_REQUIRED',
    label: JobModuleTranslationKeys.REQUESTED_DOCS_STATUS_NOT_REQUIRED,
    severity: 'secondary',
  },
  {
    code: 'OPTIONAL',
    label: JobModuleTranslationKeys.REQUESTED_DOCS_STATUS_OPTIONNAL,
    severity: 'warn',
  },
];

export const JOB_PRIORITIES = [
  {
    value: JobPriority.HIGH,
    label: TranslateKey.PRIORITY_HIGH,
  },
  {
    value: JobPriority.MEDIUM,
    label: TranslateKey.PRIORITY_MEDIUM,
  },
  {
    value: JobPriority.LOW,
    label: TranslateKey.PRIORITY_LOW,
  },
];

export const WEB_SOCKET_EVENTS = {
  APPLICATION_STATUS_UPDATE_STARTED : 'application-status-updated-started',
  APPLICATION_STATUS_UPDATE_IN_PROGRESS : 'application-status-updated-in-progress',
  APPLICATION_STATUS_UPDATE_COMPLETED : 'application-status-updated-completed',
  APPLICATION_STATUS_UPDATE_FAILED : 'application-status-updated-failed'
}

export const ADDITIONAL_INFOS_TYPES = [
  {
    label: TranslateKey.ADDITIONAL_INFO_SELECT,
    value: additionnalsInformationsInputType.INPUT_SELECT,
    icon: 'pi pi-angle-down',
  },
  {
    label: TranslateKey.ADDITIONAL_INFO_SHORT_TEXT,
    value: additionnalsInformationsInputType.INPUT_TEXT,
    icon: 'pi pi-align-left',
  },
  {
    label: TranslateKey.ADDITIONAL_INFO_LONG_TEXT,
    value: additionnalsInformationsInputType.INPUT_TEXTAREA,
    icon: 'pi pi-align-justify',
  },
  {
    label: TranslateKey.ADDITIONAL_INFO_SINGLE_CHOICE,
    value: additionnalsInformationsInputType.INPUT_RADIO,
    icon: 'pi pi-check-circle',
  },
  {
    label: TranslateKey.ADDITIONAL_INFO_MULTIPLE_CHOICE,
    value: additionnalsInformationsInputType.INPUT_CHECKBOX,
    icon: 'pi pi-list',
  },
  {
    label: TranslateKey.ADDITIONAL_INFO_NUMBER,
    value: additionnalsInformationsInputType.INPUT_NUMBER,
    icon: 'pi pi-hashtag',
  },
  {
    label: TranslateKey.ADDITIONAL_INFO_DATE,
    value: additionnalsInformationsInputType.INPUT_DATE,
    icon: 'pi pi-calendar',
  },
  {
    label: TranslateKey.ADDITIONAL_INFO_FILE_UPLOAD,
    value: additionnalsInformationsInputType.INPUT_FILE,
    icon: 'pi pi-upload',
  },
];

export const RECRUITERS_PERMISSIONS = [
  {
    id: JobRecruiterAccess.EDIT,
    label: TranslateKey.RECRUITER_EDITOR_PERMISSION,
  },
  {
    id: JobRecruiterAccess.VIEW,
    label: TranslateKey.RECRUITER_READER_PERMISSION,
  },
];

export enum VIEW_OPTIONS_TYPE {
  GRID = 'grid',
  LIST = 'list',
}

export const VIEW_OPTIONS = [
  {
    id: VIEW_OPTIONS_TYPE.GRID,
    label: TranslateKey.VIEW_GRID,
  },
  {
    id: VIEW_OPTIONS_TYPE.LIST,
    label: TranslateKey.VIEW_LIST,
  },
];

export enum HR_FLOW_TAG_NAMES {
  Favorited = 'favorited',
  Archived = 'archived',
  Searchable = 'searchable',
  JobId = 'job_id',
  CompanyId = 'company_id',
  CandidateId = 'candidate_id',
}


export const SOCIUM_PRIMARY_COLOR = '#0573E8';
export const SOCIUM_SECONDARY_COLOR = '#ffffff';

export const DEFAULT_PAGE_SIZE = 10;
